<template>
  <section class="ant-layout">
    <main class="ant-layout-content">
      <div class="saving-page">
        <div class="ant-spin-nested-loading">
          <div class="ant-spin-container">
            <div id="savingheader">
              <div class="common-header">
                <font style="vertical-align: inherit"
                  ><font style="vertical-align: inherit"> {{ $t('mine.osit') }} </font></font
                >
              </div>
              <div class="saving-page-content">
                <div class="saving-list-item saving-channel">
                  <div class="saving-title">
                    <font style="vertical-align: inherit"
                      ><font style="vertical-align: inherit"> {{ $t('mine.Select') }} </font></font
                    >
                  </div>
                  <div class="saving-way-list">
                    <dl :class="pay_way == 'bank' ? ' active' : ''" @click="changPayway('bank')" v-if="payWayList.card == 1">
                      <dt><img src="/static/image/company.png" alt="" /></dt>
                      <dd>
                        <font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit"> {{ $t('mine.Bank') }} </font></font
                        >
                      </dd>
                      <dd class="discount"></dd>
                    </dl>
                    <dl :class="pay_way == 'usdt' ? ' active' : ''" v-if="payWayList.usdt == 1" @click="changPayway('usdt')">
                      <dt><img src="/static/image/zgpay.png" alt="" /></dt>
                      <dd>
                        <font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit"> {{ $t('mine.USDT') }} </font></font
                        >
                      </dd>
                      <dd class="discount"></dd>
                    </dl>
                    <dl :class="pay_way == 'alipay' ? ' active' : ''" v-if="payWayList.alipay == 1" @click="changPayway('alipay')">
                      <dt><img src="/static/image/pay_alipay.png" alt="" /></dt>
                      <dd>
                        <font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit"> {{ $t('mine.Alipay') }} </font></font
                        >
                      </dd>
                      <dd class="discount"></dd>
                    </dl>
                    <dl :class="pay_way == 'wechat' ? ' active' : ''" v-if="payWayList.wechat == 1" @click="changPayway('wechat')">
                      <dt><img src="/static/image/weixin1.png" alt="" /></dt>
                      <dd>
                        <font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit"> {{ $t('mine.WeChat') }} </font></font
                        >
                      </dd>
                      <dd class="discount"></dd>
                    </dl>
                    <dl @click="$parent.openKefu">
                      <dt><img src="/static/image/online_recommend.png" alt="" /></dt>
                      <dd>
                        <font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit"> {{ $t('mine.Manual') }} </font></font
                        >
                      </dd>
                      <dd class="discount"></dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
            <!-- 银行卡 -->
            <div v-if="pay_way == 'bank'" id="savingdetailpage" class="saving-detail-page">
              <div class="saving-list-item">
                <div class="saving-title">
                  <div class="common-header">
                    <div class="header-title">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit"> {{ $t('mine.Submission') }} </font></font
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="saving-page-content">
                <div class="ant-collapse ant-collapse-borderless ant-collapse-icon-position-right">
                  <div class="ant-collapse-item">
                    <div role="button" tabindex="0" aria-expanded="false" class="ant-collapse-header">
                      <div class="pay-method">
                        <font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit"> {{ $t('mine.Payment') }} </font></font
                        ><img src="/static/image//company.png" alt="" /><font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit"> {{ $t('mine.Bank') }} </font></font
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saving-detail-ali-pay">
                  <div class="saving-payment-section" v-if="!(userbank.length == 0 && userUSD.length == 0)">
                    <div class="saving-payment-section-left">
                      <div class="saving-title">
                        <font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit"> {{ $t('mine.information') }} </font></font
                        >
                      </div>
                      <div class="content">
                        <div class="info" v-for="(item, index) in cardLis" :key="index">
                          <div class="list-item info-item account-label">
                            <div class="list-item-content">
                              <div class="label" :style="$i18n.locale != 'zh' ? 'width:200px' : ''">
                                <font style="vertical-align: inherit"
                                  ><font style="vertical-align: inherit"> {{ $t('mine.Payments') }} </font></font
                                >
                              </div>
                              <div id="content1" class="value">
                                <font style="vertical-align: inherit"
                                  ><font style="vertical-align: inherit"> {{ item.bank_no }} </font></font
                                >
                              </div>
                            </div>
                            <span class="copy-item" style="cursor: pointer" @click="doCopy(item.bank_no)"
                              ><font style="vertical-align: inherit"
                                ><font style="vertical-align: inherit">{{ $t('mine.Copy') }}</font></font
                              ></span
                            >
                          </div>
                          <div class="list-item info-item">
                            <div class="list-item-content">
                              <div class="label" :style="$i18n.locale != 'zh' ? 'width:200px' : ''">
                                <font style="vertical-align: inherit"
                                  ><font style="vertical-align: inherit"> {{ $t('mine.AccountNamea') }} </font></font
                                >
                              </div>
                              <div id="content2" class="value">
                                <font style="vertical-align: inherit"
                                  ><font style="vertical-align: inherit"> {{ item.bank_owner }} </font></font
                                >
                              </div>
                            </div>
                            <span class="copy-item" style="cursor: pointer" @click="doCopy(item.bank_owner)"
                              ><font style="vertical-align: inherit"
                                ><font style="vertical-align: inherit">{{ $t('mine.Copy') }} </font></font
                              ></span
                            >
                          </div>
                          <div class="list-item info-item">
                            <div class="list-item-content">
                              <div class="label" :style="$i18n.locale != 'zh' ? 'width:200px' : ''">
                                <font style="vertical-align: inherit"
                                  ><font style="vertical-align: inherit"> {{ $t('mine.Bankdeposit') }} </font></font
                                >
                              </div>
                              <div id="content2" class="value">
                                <font style="vertical-align: inherit"
                                  ><font style="vertical-align: inherit"> {{ item.bank_data.bank_name }} </font></font
                                >
                              </div>
                            </div>
                            <span class="copy-item" style="cursor: pointer" @click="doCopy(item.bank_data.bank_name)"
                              ><font style="vertical-align: inherit"
                                ><font style="vertical-align: inherit">{{ $t('mine.Copy') }}</font></font
                              ></span
                            >
                          </div>
                          <div class="list-item info-item">
                            <div class="list-item-content">
                              <div class="label" :style="$i18n.locale != 'zh' ? 'width:200px' : ''">
                                <font style="vertical-align: inherit"
                                  ><font style="vertical-align: inherit"> {{ $t('mine.BankAddress') }} </font></font
                                >
                              </div>
                              <div id="content2" class="value">
                                <font style="vertical-align: inherit"
                                  ><font style="vertical-align: inherit">{{ item.bank_address }}</font></font
                                >
                              </div>
                            </div>
                            <span class="copy-item" style="cursor: pointer" @click="doCopy(item.bank_address)"
                              ><font style="vertical-align: inherit"
                                ><font style="vertical-align: inherit">{{ $t('mine.Copy') }}</font></font
                              ></span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="saving-payment-section-right"></div>
                  </div>
                  <div class="saving-list-item">
                    <div role="separator" class="ant-divider ant-divider-horizontal"></div>
                    <div class="saving-title">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit"> {{ $t('mine.PaymentInformation') }} </font></font
                      >
                    </div>
                    <div class="process-item">
                      <div class="process-item-label">
                        <font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit"> {{ $t('mine.SelectBank') }} </font></font
                        >
                      </div>
                      <div>
                        <span class="ant-select ant-select-lg ant-select-single ant-select-show-arrow" style="width: 360px">
                          <el-select v-model="bankBox.bank" style="width: 360px" :placeholder="$t('mine.selectsupporting')">
                            <el-option v-for="item in banklist" :key="item.bank_name" :label="item.bank_name" :value="item.bank_name"> </el-option>
                          </el-select>
                        </span>
                      </div>
                    </div>
                    <div class="ant-form ant-form-horizontal">
                      <div class="ant-row ant-form-item">
                        <div class="ant-col ant-form-item-label">
                          <label for="result.payerName" class="ant-form-item-required"
                            ><font style="vertical-align: inherit"
                              ><font style="vertical-align: inherit">{{ $t('mine.PayerName') }}</font></font
                            ></label
                          >
                        </div>
                        <div class="ant-col ant-form-item-control">
                          <div class="ant-form-item-control-input">
                            <div class="ant-form-item-control-input-content"><input v-model="bankBox.bank_owner" :placeholder="$t('mine.fillname')" type="text" value="" class="ant-input" /></div>
                          </div>
                        </div>
                      </div>
                      <div class="ant-row ant-form-item">
                        <div class="ant-col ant-form-item-label">
                          <label for="result.payerName" class="ant-form-item-required"
                            ><font style="vertical-align: inherit"
                              ><font style="vertical-align: inherit">{{ $t('mine.Banknumber') }}</font></font
                            ></label
                          >
                        </div>
                        <div class="ant-col ant-form-item-control">
                          <div class="ant-form-item-control-input">
                            <div class="ant-form-item-control-input-content"><input v-model="bankBox.bank_no" :placeholder="$t('mine.fillcard')" type="text" value="" class="ant-input" /></div>
                          </div>
                        </div>
                      </div>
                      <div class="ant-row ant-form-item">
                        <div class="ant-col ant-form-item-label">
                          <label for="result.payerName" class="ant-form-item-required"
                            ><font style="vertical-align: inherit"
                              ><font style="vertical-align: inherit">{{ $t('mine.opening') }}</font></font
                            ></label
                          >
                        </div>
                        <div class="ant-col ant-form-item-control">
                          <div class="ant-form-item-control-input">
                            <div class="ant-form-item-control-input-content"><input v-model="bankBox.bank_address" :placeholder="$t('mine.address')" type="text" value="" class="ant-input" /></div>
                          </div>
                        </div>
                      </div>
                      <div class="quick-select-amount">
                        <div class="item-label">
                          <font style="vertical-align: inherit"
                            ><font style="vertical-align: inherit"> {{ $t('mine.Recharge') }} </font></font
                          >
                        </div>
                        <div class="item-content">
                          <div class="item-content-item" @click="changMey(100)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥100</font></font>
                          </div>
                          <div class="item-content-item" @click="changMey(1000)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥1000</font></font>
                          </div>
                          <div class="item-content-item" @click="changMey(5000)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥5000</font></font>
                          </div>
                          <div class="item-content-item" @click="changMey(10000)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥10000</font></font>
                          </div>
                          <div class="item-content-item" @click="changMey(50000)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥50000</font></font>
                          </div>
                        </div>
                      </div>
                      <div class="ant-row ant-form-item fund-exchange-rate">
                        <div class="ant-col ant-form-item-label">
                          <label for="result.payerName" class="ant-form-item-required"
                            ><font style="vertical-align: inherit"
                              ><font style="vertical-align: inherit">{{ $t('mine.Recharge') }}</font></font
                            ></label
                          >
                        </div>
                        <div class="ant-col ant-form-item-control">
                          <div class="ant-form-item-control-input">
                            <div class="ant-form-item-control-input-content">
                              <span class="number-currency-numberinput ant-input-affix-wrapper"><input v-model="amount" type="number" :placeholder="`${$t('mine.enterwithdrawal')} ${min_price} - ${max_price}`" class="ant-input" /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="ant-row ant-form-item">
                        <div class="ant-col ant-form-item-control">
                          <div class="ant-form-item-control-input">
                            <div class="ant-form-item-control-input-content">
                              <button class="ant-btn ant-btn-primary" @click="payTest">
                                <span
                                  ><font style="vertical-align: inherit"
                                    ><font style="vertical-align: inherit">{{ $t('mine.Submit') }}</font></font
                                  ></span
                                >
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!---->
              <div id="savingheader">
                <div class="saving-page-content">
                  <div class="saving-tips">
                    <span class="title"
                      ><font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">{{ $t('mine.measures') }}</font></font
                      ></span
                    ><font style="vertical-align: inherit"
                      ><font style="vertical-align: inherit"> {{ $t('mine.Before') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.funds') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.into') }} </font><font style="vertical-align: inherit">{{ $t('mine.Please2') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.areanother') }} </font></font
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- USDT -->
            <div v-if="pay_way == 'usdt'" id="savingdetailpage" class="saving-detail-page">
              <div class="saving-list-item">
                <div class="saving-title">
                  <div class="common-header">
                    <div class="header-title">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit"> {{ $t('mine.Submission') }} </font></font
                      >
                    </div>
                  </div>
                </div>
              </div>
              <!---->
              <div class="saving-page-content" id="zgpay">
                <div class="ant-collapse ant-collapse-borderless ant-collapse-icon-position-right">
                  <div class="ant-collapse-item">
                    <div role="button" tabindex="0" aria-expanded="false" class="ant-collapse-header">
                      <div class="pay-method">
                        <font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit"> {{ $t('mine.Payment') }} </font></font
                        ><img src="/static/image/zgpay.png" alt="" /><font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit">{{ $t('mine.USDT') }} </font></font
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saving-detail-ali-pay">
                  <div class="saving-list-item deposit-remark">
                    <div class="saving-title">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit"> {{ $t('mine.measures') }} </font></font
                      >
                    </div>
                    <p class="remark">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">{{ $t('mine.Before') }}</font
                        ><font style="vertical-align: inherit">{{ $t('mine.funds') }}</font
                        ><font style="vertical-align: inherit">{{ $t('mine.into') }}</font
                        ><font style="vertical-align: inherit">{{ $t('mine.Please2') }}</font
                        ><font style="vertical-align: inherit"> {{ $t('mine.areanother') }}</font></font
                      >
                    </p>
                  </div>
                  <div class="saving-list-item">
                    <div role="separator" class="ant-divider ant-divider-horizontal"></div>
                    <div class="saving-title">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit"> {{ $t('mine.PaymentInformation') }} </font></font
                      >
                    </div>
                    <div class="process-item">
                      <div class="process-item-label">
                        <font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit"> {{ $t('mine.wallet') }} </font></font
                        >
                      </div>
                      <div>
                        <span class="ant-select ant-select-lg ant-select-single ant-select-show-arrow" style="width: 360px">
                          <el-select v-model="meyXi" style="width: 360px" :placeholder="$t('mine.supported')" @change="getPayRange">
                            <el-option label="ERC20" value="ERC20"> </el-option>
                            <el-option label="TRC20" value="TRC20"> </el-option>
                          </el-select>
                        </span>
                      </div>
                    </div>
                    <div class="ant-form ant-form-horizontal">
                      <div class="quick-select-amount">
                        <div class="item-label">
                          <font style="vertical-align: inherit"
                            ><font style="vertical-align: inherit"> {{ $t('mine.Recharge') }} </font></font
                          >
                        </div>
                        <div class="item-content">
                          <div class="item-content-item" @click="changMey(100)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥100</font></font>
                          </div>
                          <div class="item-content-item" @click="changMey(1000)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥1000</font></font>
                          </div>
                          <div class="item-content-item" @click="changMey(5000)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥5000</font></font>
                          </div>
                          <div class="item-content-item" @click="changMey(10000)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥10000</font></font>
                          </div>
                          <div class="item-content-item" @click="changMey(50000)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥50000</font></font>
                          </div>
                        </div>
                      </div>
                      <div class="ant-row ant-form-item fund-exchange-rate">
                        <div class="ant-col ant-form-item-label">
                          <label for="result.payerName" class="ant-form-item-required"
                            ><font style="vertical-align: inherit"
                              ><font style="vertical-align: inherit">{{ $t('mine.Recharge') }}</font></font
                            ></label
                          >
                        </div>
                        <div class="ant-col ant-form-item-control">
                          <div class="ant-form-item-control-input">
                            <div class="ant-form-item-control-input-content">
                              <span class="number-currency-numberinput ant-input-affix-wrapper"><input v-model="amount" type="number" :placeholder="`${$t('mine.enterwithdrawal')} ${min_price} - ${max_price}`" class="ant-input" /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="ant-row ant-form-item fund-exchange-rate">
                        <div class="ant-col ant-form-item-label">
                          <label for="result.payerName" class="ant-form-item-required"
                            ><font style="vertical-align: inherit"
                              ><font style="vertical-align: inherit">{{ $t('mine.arrival') }} </font></font
                            ></label
                          >
                        </div>
                        <div class="ant-col ant-form-item-control">
                          <div class="ant-form-item-control-input">
                            <div class="ant-form-item-control-input-content" style="padding-top: 6px">
                              ≈ {{ amount ? Math.floor((amount / $store.state.userInfo.usdtrate) * 100) / 100 : '0.00' }} {{ $t('mine.USDT') }} &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('mine.exchange') }}{{ $store.state.userInfo.usdtrate }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="ant-row ant-form-item">
                        <div class="ant-col ant-form-item-control">
                          <div class="ant-form-item-control-input">
                            <div class="ant-form-item-control-input-content">
                              <button class="ant-btn ant-btn-primary" @click="payTest">
                                <span
                                  ><font style="vertical-align: inherit"
                                    ><font style="vertical-align: inherit">{{ $t('mine.Submit') }}</font></font
                                  ></span
                                >
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="savingheader">
                <div class="saving-page-content">
                  <div class="saving-tips">
                    <span class="title"
                      ><font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">{{ $t('mine.measures') }}</font></font
                      ></span
                    ><font style="vertical-align: inherit"
                      ><font style="vertical-align: inherit"> {{ $t('mine.Before') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.funds') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.into') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.Please2') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.areanother') }} </font></font
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- 支付宝 -->
            <div v-if="pay_way == 'alipay'" id="savingdetailpage" class="saving-detail-page">
              <div class="saving-list-item">
                <div class="saving-title">
                  <div class="common-header">
                    <div class="header-title">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit"> {{ $t('mine.Submission') }} </font></font
                      >
                    </div>
                  </div>
                </div>
              </div>
              <!---->
              <div class="saving-page-content" id="zgpay">
                <div class="ant-collapse ant-collapse-borderless ant-collapse-icon-position-right">
                  <div class="ant-collapse-item">
                    <div role="button" tabindex="0" aria-expanded="false" class="ant-collapse-header">
                      <div class="pay-method">
                        <font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit"> {{ $t('mine.Payment') }} </font></font
                        ><img src="/static/image/pay_alipay.png" alt="" /><font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit">{{ $t('mine.Alipay') }} </font></font
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saving-detail-ali-pay">
                  <div class="saving-list-item deposit-remark">
                    <div class="saving-title">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit"> {{ $t('mine.measures') }} </font></font
                      >
                    </div>
                    <p class="remark">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">{{ $t('mine.Before') }}</font
                        ><font style="vertical-align: inherit">{{ $t('mine.funds') }}</font
                        ><font style="vertical-align: inherit">{{ $t('mine.into') }}</font
                        ><font style="vertical-align: inherit">{{ $t('mine.Please2') }}</font
                        ><font style="vertical-align: inherit"> {{ $t('mine.areanother') }}</font></font
                      >
                    </p>
                  </div>
                  <div class="saving-list-item">
                    <div role="separator" class="ant-divider ant-divider-horizontal"></div>
                    <div class="saving-title">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit"> {{ $t('mine.PaymentInformation') }} </font></font
                      >
                    </div>
                    <div class="ant-form ant-form-horizontal">
                      <div class="quick-select-amount">
                        <div class="item-label">
                          <font style="vertical-align: inherit"
                            ><font style="vertical-align: inherit"> {{ $t('mine.Recharge') }} </font></font
                          >
                        </div>
                        <div class="item-content">
                          <div class="item-content-item" @click="changMey(100)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥100</font></font>
                          </div>
                          <div class="item-content-item" @click="changMey(1000)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥1000</font></font>
                          </div>
                          <div class="item-content-item" @click="changMey(5000)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥5000</font></font>
                          </div>
                          <div class="item-content-item" @click="changMey(10000)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥10000</font></font>
                          </div>
                          <div class="item-content-item" @click="changMey(50000)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥50000</font></font>
                          </div>
                        </div>
                      </div>
                      <div class="ant-row ant-form-item fund-exchange-rate">
                        <div class="ant-col ant-form-item-label">
                          <label for="result.payerName" class="ant-form-item-required"
                            ><font style="vertical-align: inherit"
                              ><font style="vertical-align: inherit">{{ $t('mine.Recharge') }}</font></font
                            ></label
                          >
                        </div>
                        <div class="ant-col ant-form-item-control">
                          <div class="ant-form-item-control-input">
                            <div class="ant-form-item-control-input-content">
                              <span class="number-currency-numberinput ant-input-affix-wrapper"><input v-model="amount" type="number" :placeholder="`${$t('mine.enterwithdrawal')} ${min_price} - ${max_price}`" class="ant-input" /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="ant-row ant-form-item">
                        <div class="ant-col ant-form-item-control">
                          <div class="ant-form-item-control-input">
                            <div class="ant-form-item-control-input-content">
                              <button class="ant-btn ant-btn-primary" @click="payTest">
                                <span
                                  ><font style="vertical-align: inherit"
                                    ><font style="vertical-align: inherit">{{ $t('mine.Submit') }} </font></font
                                  ></span
                                >
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="savingheader">
                <div class="saving-page-content">
                  <div class="saving-tips">
                    <span class="title"
                      ><font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">{{ $t('mine.measures') }}</font></font
                      ></span
                    ><font style="vertical-align: inherit"
                      ><font style="vertical-align: inherit"> {{ $t('mine.Before') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.funds') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.into') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.Please2') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.areanother') }} </font></font
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- 微信 -->
            <div v-if="pay_way == 'wechat'" id="savingdetailpage" class="saving-detail-page">
              <div class="saving-list-item">
                <div class="saving-title">
                  <div class="common-header">
                    <div class="header-title">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit"> {{ $t('mine.Submission') }} </font></font
                      >
                    </div>
                  </div>
                </div>
              </div>
              <!---->
              <div class="saving-page-content" id="zgpay">
                <div class="ant-collapse ant-collapse-borderless ant-collapse-icon-position-right">
                  <div class="ant-collapse-item">
                    <div role="button" tabindex="0" aria-expanded="false" class="ant-collapse-header">
                      <div class="pay-method">
                        <font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit"> {{ $t('mine.Payment') }} </font></font
                        ><img src="/static/image/weixin1.png" alt="" /><font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit">{{ $t('mine.WeChat') }} </font></font
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saving-detail-ali-pay">
                  <div class="saving-list-item deposit-remark">
                    <div class="saving-title">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit"> {{ $t('mine.measures') }} </font></font
                      >
                    </div>
                    <p class="remark">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">{{ $t('mine.Before') }}</font
                        ><font style="vertical-align: inherit">{{ $t('mine.funds') }}</font
                        ><font style="vertical-align: inherit">{{ $t('mine.into') }}</font
                        ><font style="vertical-align: inherit">{{ $t('mine.Please2') }}</font
                        ><font style="vertical-align: inherit"> {{ $t('mine.areanother') }}</font></font
                      >
                    </p>
                  </div>
                  <div class="saving-list-item">
                    <div role="separator" class="ant-divider ant-divider-horizontal"></div>
                    <div class="saving-title">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit"> {{ $t('mine.PaymentInformation') }} </font></font
                      >
                    </div>
                    <div class="ant-form ant-form-horizontal">
                      <div class="quick-select-amount">
                        <div class="item-label">
                          <font style="vertical-align: inherit"
                            ><font style="vertical-align: inherit"> {{ $t('mine.Recharge') }} </font></font
                          >
                        </div>
                        <div class="item-content">
                          <div class="item-content-item" @click="changMey(100)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥100</font></font>
                          </div>
                          <div class="item-content-item" @click="changMey(1000)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥1000</font></font>
                          </div>
                          <div class="item-content-item" @click="changMey(5000)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥5000</font></font>
                          </div>
                          <div class="item-content-item" @click="changMey(10000)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥10000</font></font>
                          </div>
                          <div class="item-content-item" @click="changMey(50000)">
                            <font style="vertical-align: inherit"><font style="vertical-align: inherit">￥50000</font></font>
                          </div>
                        </div>
                      </div>
                      <div class="ant-row ant-form-item fund-exchange-rate">
                        <div class="ant-col ant-form-item-label">
                          <label for="result.payerName" class="ant-form-item-required"
                            ><font style="vertical-align: inherit"
                              ><font style="vertical-align: inherit">{{ $t('mine.Recharge') }}</font></font
                            ></label
                          >
                        </div>
                        <div class="ant-col ant-form-item-control">
                          <div class="ant-form-item-control-input">
                            <div class="ant-form-item-control-input-content">
                              <span class="number-currency-numberinput ant-input-affix-wrapper"><input v-model="amount" type="number" :placeholder="`${$t('mine.enterwithdrawal')} ${min_price} - ${max_price}`" class="ant-input" /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="ant-row ant-form-item">
                        <div class="ant-col ant-form-item-control">
                          <div class="ant-form-item-control-input">
                            <div class="ant-form-item-control-input-content">
                              <button class="ant-btn ant-btn-primary" @click="payTest">
                                <span
                                  ><font style="vertical-align: inherit"
                                    ><font style="vertical-align: inherit">{{ $t('mine.Submit') }}</font></font
                                  ></span
                                >
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="savingheader">
                <div class="saving-page-content">
                  <div class="saving-tips">
                    <span class="title"
                      ><font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">{{ $t('mine.measures') }}</font></font
                      ></span
                    ><font style="vertical-align: inherit"
                      ><font style="vertical-align: inherit"> {{ $t('mine.Before') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.funds') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.into') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.Please2') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.areanother') }} </font></font
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- 人工 -->
            <div v-if="pay_way == 'rengong'" id="savingdetailpage" class="saving-detail-page">
              <div class="saving-list-item">
                <div class="saving-title">
                  <div class="common-header">
                    <div class="header-title">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit"> {{ $t('mine.Manual') }} </font></font
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="saving-page-content" id="zgpay">
                <div class="saving-detail-ali-pay">
                  <div class="saving-list-item deposit-remark">
                    <div class="saving-title">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit"> {{ $t('mine.measures') }} </font></font
                      >
                    </div>
                    <p class="remark">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">{{ $t('mine.Before') }}</font
                        ><font style="vertical-align: inherit">{{ $t('mine.funds') }}</font
                        ><font style="vertical-align: inherit">{{ $t('mine.into') }}</font
                        ><font style="vertical-align: inherit">{{ $t('mine.Please2') }}</font
                        ><font style="vertical-align: inherit"> {{ $t('mine.areanother') }}</font></font
                      >
                    </p>
                  </div>
                  <div class="saving-list-item">
                    <div role="separator" class="ant-divider ant-divider-horizontal"></div>

                    <div class="ant-form ant-form-horizontal">
                      <div class="ant-row ant-form-item">
                        <div class="ant-col ant-form-item-control">
                          <div class="ant-form-item-control-input">
                            <div class="ant-form-item-control-input-content" style="padding-top: 86px">
                              <button class="ant-btn ant-btn-primary" @click="$parent.openKefu">
                                <span
                                  ><font style="vertical-align: inherit"
                                    ><font style="vertical-align: inherit">{{ $t('mine.Successful1') }} </font></font
                                  ></span
                                >
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="savingheader">
                <div class="saving-page-content">
                  <div class="saving-tips">
                    <span class="title"
                      ><font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">{{ $t('mine.measures') }}</font></font
                      ></span
                    ><font style="vertical-align: inherit"
                      ><font style="vertical-align: inherit"> {{ $t('mine.Before') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.funds') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.into') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.Please2') }}</font
                      ><font style="vertical-align: inherit">{{ $t('mine.areanother') }} </font></font
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <!-- 没有绑定任何卡片内容 -->
    <div class="msgBox__modal__2kbbd" data-analytics="button" data-label="msg关闭" v-if="userbank.length == 0 && userUSD.length == 0" style="display: block">
      <div class="msgBox__modal_HomeAreat_model__2obMO msgBox__modal_CuorsterAreat_model__wwzuA">
        <div class="msgBox__notice_header__kkFdX">
          <span class="msgBox__text__2ODn2" title="">{{ $t('mine.reminder') }}</span
          ><span class="msgBox__close_icon__3J9a5" @click="$router.back()"></span>
        </div>
        <div class="msgBox__notice_content__3Tozy msgBox__notice_content_height__Z3O1m">
          <div class="msgBox__flex__-7cOr common__scroll_bar__28TB7" style="height: 190px !important">
            {{ $t('mine.also') }}

            <el-button type="info" @click="$parent.goNav('/bankSet')" style="display: flex; align-items: center; justify-content: center; color: #fff; margin: 40px auto">{{ $t('mine.binding') }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'recharge',
  data() {
    return {
      pay_way: 'rengong',
      bankBox: {},
      payInfo: {},
      amount: null,
      cardLis: [],
      banklist: [],
      bankBox: {},
      meyXi: 'ERC20',
      payWayList: {},
      min_price: 100,
      max_price: 10000,
      userbank: [],
      userUSD: [1],
    };
  },
  created() {
    let that = this;
    that.getPayWay();
    that.getBanklist();
    that.getcard();
    // that.getcard();
    // that.getBanklist();
  },
  methods: {
    getuseCardlist() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) {
          that.userbank = res.data;
        }
      });
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.userUSD = res.data;
        }
      });
    },
    getPayRange() {
      let that = this;
      let type = null;

      if (that.pay_way == 'bank') {
        type = 'bank';
      }
      if (that.pay_way == 'wechat') {
        type = 'wechat';
      }
      if (that.pay_way == 'alipay') {
        type = 'alipay';
      }
      if (that.pay_way == 'alipay') {
        type = 'alipay';
      }
      if (that.pay_way == 'usdt') {
        if (that.meyXi == 'ERC20') {
          type = 'usdt-erc20';
        }
        if (that.meyXi == 'TRC20') {
          type = 'usdt-trc20';
        }
      }
      // bank/wechat/alipay/usdt-erc20/usdt-trc20/ebpay    min_price max_price
      that.showLoading();

      that.$apiFun
        .post('/api/getPayRange', { type })
        .then(res => {
          if (res.code == 200) {
            that.min_price = res.data.min_price;
            that.max_price = res.data.max_price;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getPayWay() {
      let that = this;
      that.showLoading();

      that.$apiFun
        .get('/api/get_pay_way', {})
        .then(res => {
          if (res.code == 200) {
            that.payWayList = res.data;
            that.payWayList.rengong = 1;
            let obj = that.payWayList;
            for (let i in obj) {
              if (obj[i] == 1) {
                that.pay_way = i == 'card' ? 'bank' : i;
                that.hideLoading();
                that.getPayRange();
                return;
              }
            }
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    payTest() {
      let that = this;
      let info = {};

      // bank 情况下  bank  bank_address  bank_no  bank_owner
      if (that.pay_way == 'bank') {
        info = {
          paytype: that.pay_way,
          amount: that.amount * 1,
          bank: that.bankBox.bank,
          bank_address: that.bankBox.bank_address,
          bank_no: that.bankBox.bank_no,
          bank_owner: that.bankBox.bank_owner,
        };
        console.log(info);
        // 银行卡信息内容的限制
        if (!info.bank_owner) {
          that.showTost(0, that.$t('mine.enterdepositor'));
          return;
        }
        if (!info.bank) {
          that.showTost(0, that.$t('mine.enterbank'));
          return;
        }

        if (!info.bank_no) {
          that.showTost(0, that.$t('mine.enterbanks'));
          return;
        }
        if (!info.bank_address) {
          that.showTost(0, that.$t('mine.enteraccount'));
          return;
        }
      } else {
        //暂时
        info = {
          paytype: that.pay_way,
          amount: that.amount * 1,
        };
      }
      if (that.pay_way == 'usdt') {
        info.catepay = that.meyXi;
      }
      // usdt 情况下  catepay 必填

      // 支付的金额判断
      if (info.amount < that.min_price || info.amount > that.max_price) {
        that.showTost(0, `${that.$t('mine.enteramount')}${that.min_price}-${that.max_price}${that.$t('mine.SuccBetweenessful')}`);
        return;
      }
      that.showLoading();
      info.paytype = info.paytype == 'wechat' ? 'wxpay' : info.paytype;
      that.$apiFun
        .post('/api/recharge', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.amount = null;
            if (that.pay_way == 'bank') {
              that.showTost(1, that.$t('mine.Submitted'));
              that.bankBox = {};
              that.amount = null;
              that.hideLoading();
              setTimeout(() => {
                that.$router.push({ path: '/transRecord' });
              }, 2000);
              return;
            }
            that.bankBox = {};
            that.amount = null;
            that.showTost(1, that.$t('mine.Jumping'));
            setTimeout(() => {
              that.$router.push({ path: '/transRecord' });
            }, 2000);
            const routeData = this.$router.resolve({
              path: '/payInfo',
              query: { deposit_no: res.message },
            });

            window.open(routeData.href, '_blank');
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changMey(val) {
      this.amount = val * 1;
    },
    getBanklist() {
      let that = this;
      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getcard() {
      let that = this;
      that.showLoading();
      that.$apiFun
        .post('/api/getpaybank', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.cardLis = res.data;

            that.hideLoading();
          }
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changPayway(val) {
      let that = this;
      if (val == that.pay_way) {
        return;
      }
      that.pay_way = val;
      that.bankBox = {};
      that.payInfo = {};
      that.amount = null;
      that.getPayRange();
    },
    goNav(url) {
      let that = this;
      that.$parent.goNav(url);
    },
    doCopy(msg) {
      let that = this;
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.showTost(1, that.$t('mine.Copysuccessfully'));
    },
    getUserInfo() {
      let that = this;
      that.$parent.getUserInfo();
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getuseCardlist();
    });
  },
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/main_81ba8019.85ebbbbe.css';

@import '../../../static/css/saving.css';
.content {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/mine/recharge.vue